import type { GameCommand } from "../../semantic-command";
import type { GameplayEvaluationReceipt } from "../shared/adapter";
import type { CardTurnSpec } from "./spec";

export function repairCommandsForCardTurn(spec: CardTurnSpec, failedReceipt: GameplayEvaluationReceipt): readonly GameCommand[] | null {
  const failed = new Set(failedReceipt.checks.filter((check) => !check.passed).map((check) => check.id));
  if (!failed.has("player-winnable")) return null;
  return [{ type: "set-params", params: { roundsToWin: Math.floor(spec.params.deckSize / 2) + 1 } }];
}
